export default "__VITE_PUBLIC_ASSET__f9933eb1__"